export default defineNuxtPlugin(async () => {
  const { initialize } = useBehavioralBotDetection()
  
  // Initialize bot detection on app mount
  if (process.client) {
    await initialize()
  }
})

